module.exports = __webpack_public_path__ + "static/img/son12_active.5c0359eb.png";